 
import LogoI from "../../img/chef1.png";
import BikeDeliveryI from "../../img/delivery.png";
import HeroBgI from "../../img/hero-bg.png";
import EmptyCartI from "../../img/emptyCart.svg";
import NotFoundI from "../../img/NotFound.svg"; 


// Exports
export const Logo = LogoI 
export const BikeDelivery = BikeDeliveryI
export const HeroBg = HeroBgI 
export const EmptyCartImg = EmptyCartI
export const NotFoundImg = NotFoundI 